<template>
  <div class="page">
    <!--bottom-toolbar></bottom-toolbar-->
    <div class="page-content">
  		<page-nav-bar currentServiceName="MoneyRoad" subNavTitle="Import account report" :returnPreviousPage="true"></page-nav-bar>
      <div class="row rowBackgroundImage marginTopList">
      </div>
      <div class="layoutSubtitle"/>
      <f7-list class="searchbar-not-found">
        <f7-list-item title="Nothing found"></f7-list-item>
      </f7-list>
      <div class="webdatalist">
        <f7-list class="searchbar-found polsize" id="bank-list">
          <f7-list-item
            v-for="account in this.report"
            v-bind:media="'<i class=\'icon list-icon ' + getClassStatus(account.status) + '\'></i>'"
            class="bankAccountList boxRequest"
            :key="account.line"
            :title="account.line + ': ' + account.name"
            :subtitle="account.status">{{account.description}}
          </f7-list-item>
        </f7-list>
      </div>
    </div>
  </div>
</template>

<script>

import pageNavBar from '@/components/common/pageNavBar.vue'
import bottomToolbar from '@/components/bottomToolbar/bottomToolbar.vue'

export default {
  name: 'ImportBankAccountReportList',
  components: {
    'page-nav-bar': pageNavBar,
    'bottom-toolbar': bottomToolbar
  },
  data: () => {
    return {
      report: []
    }
  },
  created () {
    this.$bus.on('refresh-bank-accounts-import-report', () => {
      this.report = []
      this.report = this.$engine.bankAccounts.getImportReport()
    })
    this.report = this.$engine.bankAccounts.getImportReport()
  },
  computed: {
    getReport () {
      return this.report
    }
  },
  methods: {
    getClassStatus (value) {
      var color = ''
      if (value === 1) {
        color = 'icon-account-green-bank'
      } else {
        color = 'icon-account-red-bank'
      }
      return color
    }
  }
}
</script>

<style>
.bankAccountList>.item-link>.item-content>.item-inner>.item-title-row>.item-title {
  color: #12bcf1 !important;
}
.polsize {
  font-size: 12px;
}
.icon-account-red-bank {
  background-image: url('../../assets/static/images/banks.png');
}
.icon-account-green-bank {
  background-image: url('../../assets/static/images/account.png');
}
.rowBackgroundImage {
  background-image: url('../../assets/static/images/MenuFont.png');
  background-size: contain;
}
</style>



// WEBPACK FOOTER //
// CMImportBankAccountReport.vue?0dd0ab96